import React from 'react';
export const WixDesignSystemContext = React.createContext({
    newColorsBranding: true,
    newBrandingClass: 'no-brand',
    mobile: false,
    compactMode: false,
});
//# sourceMappingURL=context.js.map